import React from 'react';
const CTA = () => {
  return <section className="w-full bg-gradient-to-br from-orange-400 via-orange-500 to-amber-500 py-12 sm:py-16 md:py-20 lg:py-[5.75rem] relative overflow-hidden" data-id="element-80">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.06]" data-id="element-81">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-82"></div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-83">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 tracking-tight px-2" data-id="element-84">
          Build forms that feel natural — and deliver cleaner data.
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-2" data-id="element-85">
          Start free today. Scale into advanced, human-like experiences when
          you're ready — with reliability and control built in.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-86">
          <a href="https://accounts.fluid-form.ai/sign-up" target="_blank" onClick={() => window.gtag('event', 'signup_click', {
          source: 'nav_login'
        })} rel="noopener noreferrer" className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-orange-600 rounded-lg font-bold text-base sm:text-lg hover:bg-gray-50 transition-all shadow-xl w-full sm:w-auto min-h-[44px] flex items-center justify-center" data-id="element-87">
            Try it now
          </a>
        </div>

        <p className="text-white/70 mt-4 sm:mt-6 text-xs sm:text-sm" data-id="element-88">
          No credit card required.
        </p>
      </div>
    </section>;
};
export default CTA;